import { ExperienceActivity } from "types/experience-activity";

export class Experience {
    activities: ExperienceActivity[];
    description: { [key: string]: string };
    id: number;
    parentId?: number;
    imageReference1x1: string;
    imageReference16x9: string;
    maximumGapTime: number;
    name: { [key: string]: string };
    sortOrder: number;
    /**
     * Requests are the only way to book this experience, so its rules are Inquiry-typed. Treated
     * like the booking-request flow everywhere availability is judged: it has no bookable seats to
     * run out of, and a booking made against an Inquiry rule becomes a request anyway (BOOK-3911).
     */
    bookingRequestOnly: boolean;
    /**
     * Shown to guests as information only: its rules are text rows without times, and its own
     * description is the message (BOOK-3969).
     */
    informationOnly: boolean;
    // Calculated by filtering logic
    unavailable: boolean;

    constructor(values?: Partial<Experience>) {
        this.activities =
            values?.activities?.map((activity) => new ExperienceActivity(activity)) ?? [];
        this.description = values?.description ?? {};
        this.id = values?.id ?? 0;
        this.parentId = values?.parentId;
        this.imageReference1x1 = values?.imageReference1x1 ?? "";
        this.imageReference16x9 = values?.imageReference16x9 ?? "";
        this.maximumGapTime = values?.maximumGapTime ?? 0;
        this.name = values?.name ?? {};
        this.sortOrder = values?.sortOrder ?? 0;
        this.bookingRequestOnly = values?.bookingRequestOnly ?? false;
        this.informationOnly = values?.informationOnly ?? false;
        this.unavailable = values?.unavailable ?? false;
    }

    clone(): Experience {
        return new Experience(this);
    }
}

/**
 * availableTimes identifies an experience by the variant that owns the rules, usually a copy, while
 * the catalogue, day states and the modal all key on the family. Compare and address experiences by
 * this, never by `id` alone, or a copy and its origin read as two different things (BOOK-3910).
 *
 * A plain object is accepted on purpose: availableTimes rows reach some call sites unconstructed.
 */
export function getFamilyId(experience: Pick<Experience, "id" | "parentId">): number {
    return experience.parentId ?? experience.id;
}
